import { makeStyles, mergeClasses } from "@fluentui/react-components";
import * as React from "react";

export type GridProps = {
  children: React.ReactNode;
  fluid?: boolean;
  className?: string;
  id?: string;
  role?: React.AriaRole;
  testid?: string;
};

const useStyles = makeStyles({
  container: {
    marginRight: "auto",
    marginLeft: "auto",
    paddingRight: "0.75rem",
    paddingLeft: "0.75rem",
    width: "100%",

    maxWidth: "1280px",

    "@media (max-width: 1422px)": {
      maxWidth: "954px",
    },

    "@media (max-width: 953px) and (min-width: 541px)": {
      maxWidth: "628px",
      paddingRight: "5%",
      paddingLeft: "5%",
      width: "90%",
      boxSizing: "content-box",
    },

    "@media (max-width: 540px)": {
      width: "95%",
    },
  },

  fluidContainer: {
    width: "100%",
    marginRight: "auto",
    marginLeft: "auto",
    paddingRight: "0.75rem",
    paddingLeft: "0.75rem",
    "@media (min-width: 1084px)": {
      paddingRight: "5%",
      paddingLeft: "5%",
      width: "90%",
      boxSizing: "content-box",
    },
  },
});

export const Grid: React.FC<GridProps> = ({
  fluid,
  children,
  className,
  id,
  testid,
  role,
}) => {
  const styles = useStyles();
  return (
    <div
      id={id}
      role={role}
      data-testid={testid ?? ""}
      className={mergeClasses(
        fluid ? styles.fluidContainer : styles.container,
        className
      )}
    >
      {children}
    </div>
  );
};
